const izquierda = document.querySelectorAll(".izquierda-prop")
const derecha = document.querySelectorAll(".derecha-prop")
const contenedores = document.getElementsByClassName("bodegas")

//Desplazamiento de propiedades --------------------------------------------------------------------
for(var i = 0;i<=3;i++){
  const contenedores = document.getElementsByClassName("bodegas")[i]
  izquierda[i].addEventListener("click", function(){
    contenedores.scrollBy({
      left: -900, // Ajusta la cantidad de desplazamiento
      behavior: 'smooth' // Desplazamiento suave
    });
  })
  derecha[i].addEventListener("click", function(){
    contenedores.scrollBy({
      left: 900, // Ajusta la cantidad de desplazamiento
      behavior: 'smooth' // Desplazamiento suave
    });
  })
}

for(var i = 0; i<=3 ; i++){
  const filtroRenta = document.querySelectorAll(".filtro-r")[i]
  const filtroVenta = document.querySelectorAll(".filtro-v")[i]
  const bodegas = document.querySelectorAll('.bodegas')[i]

  filtroRenta.addEventListener("click",function(){
    filtroRenta.style.backgroundColor = "rgb(3, 21, 101)"
    filtroRenta.style.color = "rgb(255,255,255)"
    filtroVenta.style.backgroundColor = "rgb(255,255,255)"
    filtroVenta.style.color = "rgb(0,0,0)"
    for(var i = 0; i < bodegas.children.length; i++){
      if(bodegas.children[i].children[0].children[0].innerHTML == "venta"){
        bodegas.children[i].style.display  = "none"
      }
      else{
        bodegas.children[i].style.display  = "block"
      }
    }
  })
  filtroVenta.addEventListener("click",function(){
    filtroVenta.style.backgroundColor = "rgb(3, 21, 101)"
    filtroVenta.style.color = "rgb(255,255,255)"
    filtroRenta.style.color = "rgb(0,0,0)"
    filtroRenta.style.backgroundColor = "rgb(255,255,255)"
    for(var i = 0; i < bodegas.children.length; i++){
      if(bodegas.children[i].children[0].children[0].innerHTML == "renta"){
        bodegas.children[i].style.display  = "none"
      }
      else{
        bodegas.children[i].style.display  = "block"
      }
    }
  })
}





document.getElementsByClassName("menu-button")[0].addEventListener("click", function(){
  const linksnav = document.getElementsByClassName("nav_links")[0]
  linksnav.classList.toggle("show")
})